function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-statements */
import React from 'react';
import { AppError } from 'src/redux/types';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { invalidateStopSellingItem, stopSellingItem } from 'src/redux/actions';
import { updateWalletBalance } from '@profile/src/redux/remoteActions';
import styles from './styles.module.scss';
import icClose from 'assets/svg/ic_close.svg';
import { logStopSellHeroEvent } from 'src/utils/analytic';
import Modal from 'src/Components/Modal';
import Button from '../../Components/Button';
import { HeroStatus } from 'src/utils/types';
import { useTestId } from '@wolffun/testable-id';

const StopHeroSaleTransactionModal = ({
  hero,
  onClose,
  onCompleted,
  onFailure
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const dispatch = useTypedDispatch();
  const stopSellingItemLoading = useTypedSelector(state => state.stopSellingItem.loading);
  const thcBalance = useTypedSelector(state => state.connectWallet.thcBalance);
  const thgBalance = useTypedSelector(state => state.connectWallet.thgBalance);
  const userId = useTypedSelector(state => {
    var _state$userProfile$us;

    return (_state$userProfile$us = state.userProfile.user) === null || _state$userProfile$us === void 0 ? void 0 : _state$userProfile$us.id;
  });
  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    dispatch(updateWalletBalance());
    dispatch(invalidateStopSellingItem());
  };

  const isItemSelling = hero.hero.status === HeroStatus.ON_MARKET;

  const onStopSellingButtonPressed = async () => {
    const {
      blockchainId
    } = hero.hero;
    const {
      data,
      error
    } = await dispatch(stopSellingItem({
      blockchainId
    }));

    if (error !== undefined && error !== AppError.NO_ERROR) {
      onFailure(error);
      return;
    }

    onCompleted();

    if (thcBalance && thgBalance && hero.hero.systemPrice && userId) {
      logStopSellHeroEvent({
        THG: thgBalance,
        THC: thcBalance,
        battleCapTHC: hero.hero.battleCapTHC,
        limitTHCBattleCap: hero.hero.totalBattleCapTHC,
        heroLevel: hero.hero.level,
        heroRarity: hero.hero.rarity,
        heroToken: hero.hero.tokenId,
        heroTypeId: hero.hero.heroTypeId,
        price: hero.hero.systemPrice,
        skinRarity: hero.hero.skinRarity,
        transactionId: (data === null || data === void 0 ? void 0 : data.id) || hero.hero.nftId,
        trophyLevel: hero.hero.trophy,
        userId
      });
    }
  };

  const renderContent = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.subtitle
  }, "Are you sure you want to stop selling this item?"), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, _extends({
    title: "Cancel",
    type: "secondary",
    disabled: stopSellingItemLoading,
    onClick: onClose
  }, generateTestIdProps('stop-modal', 'primary-button'))), !isItemSelling ? /*#__PURE__*/React.createElement(Button, {
    title: "Stop selling",
    disabled: true
  }) : stopSellingItemLoading ? /*#__PURE__*/React.createElement(Button, {
    loading: true,
    title: "Processing...",
    disabled: true
  }) : /*#__PURE__*/React.createElement(Button, _extends({
    className: styles.button,
    title: "Stop selling",
    onClick: onStopSellingButtonPressed
  }, generateTestIdProps('stop-modal', 'primary-button')))));

  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Stop selling"), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    disabled: stopSellingItemLoading,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, renderContent())));
};

export default StopHeroSaleTransactionModal;